import { Flex, Input } from "@chakra-ui/react";
import { yupResolver } from '@hookform/resolvers/yup';
import Card from "components/Card/Card";
import TableFilterBox from "components/TableFilterBox"
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import * as yup from "yup";

const schema = yup.object().shape({
    start_date: yup.string()
});

interface Props {
    onFilter: (args1?: any) => void
}

interface FormData {
    start_date: string
    end_date: string
}

const Filters = ({ onFilter }: Props) => {
    const [form, setForm] = useState<FormData>({
        start_date: "",
        end_date: ""
    });

    const methods = useForm<any>({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        resolver: yupResolver(schema)
    });

    const {
        getValues,
        register,
        control,
        watch,
        formState: { errors },
        reset
    } = methods;

    const fields: any[] = [
        {
            name: 'start_date',
            label: 'Data Inicial',
            colSpan: 1,
            component:
                <Input
                    value={form.start_date}
                    onChange={({target}) => setForm({...form, start_date: target.value})}
                    as={InputMask}
                    mask="99/99/9999"
                    borderRadius="8px"
                    fontSize="md"
                />
        },
        {
            name: 'end_date',
            label: 'Data Final',
            colSpan: 1,
            component:
                <Input
                    value={form.end_date}
                    onChange={({target}) => setForm({...form, end_date: target.value})}
                    as={InputMask}
                    mask="99/99/9999"
                    borderRadius="8px"
                    fontSize="md"
                />
        }
    ]

    const handleFilter = () => {
        const values = form;
        const paramsValues: any = {};

        if(values.start_date && values.start_date !== '') {
            let splitDate = values.start_date.split("/");
            paramsValues.start_date = new Date(Number(splitDate[2]), Number(splitDate[1]) - 1, Number(splitDate[0]))
        }

        if(values.end_date && values.end_date !== '') {
            let splitDate = values.end_date.split("/");
            paramsValues.end_date = new Date(Number(splitDate[2]), Number(splitDate[1]) - 1, Number(splitDate[0]))
        }

        onFilter(paramsValues);
    }

    const handleClear = () => {
        setForm({
            start_date: "",
            end_date: ""
        })
        onFilter();
    }

    return (
        <Flex w="full" mb={4}>
            <Card>
                <FormProvider {...methods}>
                    <TableFilterBox fields={fields} handleFilter={handleFilter} handleClear={handleClear} />
                </FormProvider>
            </Card>
        </Flex>
    )
}

export default Filters